export default {
  headerDefault: '#000',
  headerScrolling: '#191919',
  blackText: '#212529',
  grayText: '#444',
  lightGrayText: '#505763',
  star: '#ffa500',
  redAction: '#ec5252',
};
